<template>
  <div>
    <h3>Зарегистрировано случаев с начала месяца</h3>
    <p class="text-xs-right" v-if="data.lastUpdate"><i class="fas fa-clock"></i> {{ data.lastUpdate }}</p>
    <v-data-table
      :headers="headers"
      :items="data.data"
      :loading="data.inProgress"
      :hide-actions="true"
      no-data-text="Статистика недоступна"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.name }}</td>
          <td><b>{{ props.item.count }}</b></td>
          <td><b>{{ props.item.avgCount }}</b></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'CaseRegistrationStats',
  props: {
    data: {
      Type: Object
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'ФИО',
          align: 'left',
          sortable: false,
          value: 'name',
          width: '120px'
        },
        {
          text: 'Всего',
          sortable: false,
          value: 'count',
          width: '50px'
        },
        {
          text: 'Среднее за день',
          sortable: false,
          value: 'avgCount',
          width: '80px'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Walldash/CaseRegistrationStats.vue